"use client";
import { jsxs as C, jsx as S } from "react/jsx-runtime";
import h from "../icon/Icon.js";
import $ from "../visually-hidden/VisuallyHidden.js";
import { css as y } from "@emotion/react";
import m from "@emotion/styled";
import { COLORS as x } from "../../tokens/colors/Colors.js";
import { ICON_COLORS as D } from "../../tokens/icon-colors/IconColors.js";
import { LINE_HEIGHTS as O } from "../../tokens/line-heights/LineHeights.js";
import { SPACINGS as t } from "../../tokens/spacings/Spacings.js";
const T = ({ children: c, compact: i, index: o, sortable: e, sorting: l, ...I }) => {
  var p, r, u;
  const f = ((p = e == null ? void 0 : e.labels) == null ? void 0 : p.neutral) ?? "Sortable", a = "caretUpDown";
  let n = f, d = a;
  return o === (l == null ? void 0 : l.column) && (l.direction === "asc" ? (n = ((r = e == null ? void 0 : e.labels) == null ? void 0 : r.ascending) ?? "Ascending", d = "caretUp") : l.direction === "desc" ? (n = ((u = e == null ? void 0 : e.labels) == null ? void 0 : u.descending) ?? "Descending", d = "caretDown") : (n = f, d = a)), /* @__PURE__ */ C(s, { ...I, feCompact: i, sortable: e, children: [
    c,
    e && /* @__PURE__ */ C(
      L,
      {
        onClick: e.onClick,
        stSorted: o == (l == null ? void 0 : l.column),
        direction: l == null ? void 0 : l.direction,
        children: [
          /* @__PURE__ */ S($, { children: n }),
          /* @__PURE__ */ S(N, { feIcon: d })
        ]
      }
    )
  ] });
};
T.displayName = "TableCell";
const s = m.td(
  ({ feCompact: c, sortable: i }) => y`
		padding: ${c ? t.xs : t.md} ${t.md};
		position: ${i && "relative"};
		text-align: left;
	`
), L = m.button(
  ({ direction: c, stSorted: i }) => y`
		color: ${i && c ? D.gray : x.gray500};
		line-height: ${O.sm};
		margin-left: ${t.xs};
		vertical-align: middle;

		&::after {
			content: '';
			inset: 0;
			position: absolute;
		}
	`
), N = m(h)`
	color: inherit;
`;
export {
  T as default
};
